<div
  *ngIf="isLgUp; else searchMobile"
  class="searchbarDesktop__container"
  [ngClass]="{open: isSearchHeaderOpen, inProgress: isSearchActive}"
>
  <input
    *ngIf="!isSearchHeaderOpen"
    type="text"
    class="vc-form-text__input searchbarDesktop__input"
    i18n-placeholder="@@HEADER.SEARCH.INPUT_PLACEHOLDER"
    placeholder="Search for items, designers..."
    [value]="searchValue"
    name="headerSearch"
    id="headerSearch"
    (focus)="openSearchHeader()"
    spellcheck="false"
  />
  <label for="headerSearch" class="visuallyhidden" i18n="@@HEADER.SEARCH.INPUT_PLACEHOLDER"
    >Search for items, designers...</label
  >
  <div #searchDesktop class="searchbarDesktop__contentContainer"></div>
  <vc-sprite-icons class="searchbarDesktop__icon" name="search"></vc-sprite-icons>
  <span
    *ngIf="searchValue !== ''"
    class="searchbar__clear searchbar__clear--header"
    (click)="clearSearch()"
    i18n="@@HEADER.SEARCH.CLEAR_BTN"
    >Clear</span
  >
  <button *ngIf="isSearchActive" class="searchbarDesktop__closeButton" (click)="leaveSearchHeader()">
    <span class="searchbarDesktop__closeButton__cross"></span>
  </button>
</div>

<ng-template #searchMobile>
  <div class="searchbarMobile__container vc-d-lg-none">
    <button class="searchbarMobile__button" (click)="openSearchbarModal()">
      <vc-sprite-icons name="search" class="searchbarMobile__icon"></vc-sprite-icons>
      <span *ngIf="searchValue !== ''; else placeholder" class="searchbarMobile__text">{{ searchValue }}</span>
      <ng-template #placeholder>
        <span class="searchbarMobile__placeholder" i18n="@@HEADER.SEARCH.INPUT_PLACEHOLDER"
          >Search for items, designers...</span
        >
      </ng-template>
    </button>
    <span
      *ngIf="searchValue !== ''"
      class="searchbar__clear searchbar__clear--header"
      (click)="clearSearch()"
      i18n="@@HEADER.SEARCH.CLEAR_BTN"
      >Clear</span
    >
  </div>
</ng-template>
